export const overrideButton = ({ ownerState, theme }) => {
  const customStyles = {
    textTransform: "none",
    fontWeight: "500",
    paddingTop: "10px",
    paddingBottom: "10px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  };

  const color = theme.palette[ownerState.color].main;

  switch (ownerState.variant) {
    case "outlined":
      customStyles.backgroundColor = "transparent";
      customStyles.border = "1px solid";
      customStyles.color = color;
      customStyles["&:active, &:hover"] = {
        backgroundColor: color,
        color: "#fff",
      };

      break;
    case "contained":
      customStyles.backgroundColor = color;

      break;
    default:
      break;
  }

  return customStyles;
};
